module.exports = __webpack_public_path__ + "assets/img/poss.webp?825ecf411cdbbd30408f002d9c00ab5c";